module.exports = __webpack_public_path__ + "static/media/cross.75deb56e.svg";